export enum RolesUser {
    Undefined   = 0, // Cliente não identificado
    Anonymous   = 1, // Cliente anônimo
    Identified  = 2, // Cliente identificado
    Registered  = 3, // Cliente registrado
    Activated   = 4, // Cliente ativo
    Expired     = 5, // Cliente expirado
}